import { render, staticRenderFns } from "./PanelContentItemShowModal.vue?vue&type=template&id=c4087ca0&"
import script from "./PanelContentItemShowModal.vue?vue&type=script&lang=ts&"
export * from "./PanelContentItemShowModal.vue?vue&type=script&lang=ts&"
import style0 from "./PanelContentItemShowModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports